export const checkPathMatch = (pages) => {
  const currentPath = window.location.pathname;

  return pages.some((page) => currentPath === `/${page}`);
};
